
import { useIsVisible } from '@components';
import { useSelector } from 'react-redux';
import { BlueButton } from '@share/components';

import { faBuilding, faCamera, faShieldHalved, faTags } from '@fortawesome/free-solid-svg-icons';
import { FunctionalRootState, getPreferenceFromAccount } from '@share/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ILoginState } from '@share/store/slices';

import Mountain from '@assets/images/ashevilleplay/mountains.jpg';

import './style.scss';
import { BANNER_PRIMARY_PHOTO_URL_FIELD_KEY } from '@share/common-types';

interface IProps {
  onClick: () => void;
}

export function SearchAshevillePlayRealDiscountMessage({ onClick }: IProps) {
  const [elementRef, isVisible] = useIsVisible<HTMLDivElement>();

  const loginStore: ILoginState = useSelector((state: FunctionalRootState) => state.loginStore);
  const { account } = loginStore;

  const imageUrl = getPreferenceFromAccount(account, BANNER_PRIMARY_PHOTO_URL_FIELD_KEY);

  const image = imageUrl ? imageUrl : Mountain;
  
  return (
    <div ref={elementRef} className="search-asheville-play-real-discount-message">
      <div 
        className={`search-asheville-play-real-discount-message__content ${isVisible ? 'animated-message' : ''}`} 
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="search-asheville-play-real-discount-message__wrapper opacity-mask" data-opacity-mask="rgba(0, 0, 0, 0.3)">
          <div className="col-lg-7">
            <small>Real Discounts You Won't Find Anywhere Else</small>
            
            <h3>Why book a hotel with <span className="fw-bold text-brand-yellow">Asheville Play?</span></h3>
            
            <p className="lead" style={{ fontSize: '1.1rem' }}>
              Every hotel on Asheville Play is personally vetted, locally loved, and priced with your wallet in mind. Whether you're craving mountain views, walk-to-downtown perks, or a romantic escape, we've got your dream stay waiting.
            </p>

            <ul style={{ fontSize: '1.3rem' }}>
              <li><FontAwesomeIcon icon={faBuilding} /> Curated hotel picks — only the best make the cut</li>
              <li><FontAwesomeIcon icon={faTags} /> Save up to 15% compared to other sites</li>
              <li><FontAwesomeIcon icon={faShieldHalved} /> Secure booking with zero hidden fees</li>
              <li><FontAwesomeIcon icon={faCamera} /> Book a hotel and get discounts on local attractions</li>
            </ul>

            <BlueButton onClick={onClick}>See Our Hotel Deals</BlueButton>
          </div>
        </div>
      </div>
    </div>
  );
}
